import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updateOrganization = (orgId, payload, callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_ORGANIZATION' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(`/ads/org/${orgId}`, payload, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_ORGANIZATION_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'UPDATING_ORGANIZATION_FAILED',
              payload: `Failed to update organization`,
            });
            if (typeof errCb === 'function') {
              errCb(`Failed to update organization`);
            }
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_ORGANIZATION_FAILED',
            payload: `Failed to update organization`,
          });
          if (typeof errCb === 'function') {
            errCb(
              e?.response?.status === 401
                ? `You need the ROLE_ADMIN role to update this organization`
                : e?.response?.data?.message || `Failed to update organization`,
            );
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'UPDATING_ORGANIZATION_FAILED',
        payload: `Failed to update organization`,
      });
      if (typeof errCb === 'function') {
        errCb(`Failed to update organization`);
      }
    }
  };
};

export default updateOrganization;
